import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';


@Directive({
  selector: '[appValidateEqual][formControlName], [appValidateEqual][formControl], [appValidateEqual][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidatorDirective), multi: true }]
})
export class EqualValidatorDirective implements Validator {
  constructor( @Attribute('appValidateEqual') public validateEqual: string, @Attribute('reverse') public reverse: string) {}

  private get isReverse() {
    if (!this.reverse) {
      return false;
    }
    return this.reverse === 'true' ? true : false;
  }

validate(c: AbstractControl): { [key: string]: any } {
  // self value (e.g. retype password)
  const v = c.value;
  // control value (e.g. password)
  const e = c.root.get(this.validateEqual);
  // value not equal
  if (e && v !== e.value && !this.isReverse) {
    return {
      validateEqual: false
    };
  }

  if (e && v === e.value && this.isReverse) {
    delete e.errors['appValidateEqual'];
    if (!Object.keys(e.errors).length) {
      e.setErrors(null);
    }
  }

  if (e && v !== e.value && this.isReverse) {
    e.setErrors({ validateEqual: false });
  }


  return null;
}
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/equal-validator.directive.ts